import React from 'react';
import PropTypes from 'prop-types';
import ValuePropsModal from './ValuePropsModal';
import Lists from 'images/Lists@2x.jpg';
import { FormattedMessage } from 'react-intl';

export default function CollabChecklistsValuePropsModal({ onRequestClose }) {
  const formattedTitle = (
    <FormattedMessage
      id="ValueProps.collabChecklists.title"
      defaultMessage="Collaborate on Checklists"
      description="Title to name Todo Lists"
    />
  );

  const formattedDescription = (
    <FormattedMessage
      id="ValueProps.collabChecklists.description"
      defaultMessage="Get it organized. Get it done."
      description="Description to explain what are Todos"
    />
  );

  const formattedChecklistItems = [
    <FormattedMessage
      id="ValueProps.collabChecklists.valuePropA"
      defaultMessage="The project owner shoots you a Checklist. You knock it out, get paid, and go home!"
      description="Value prop of Todos feature"
    />,
    <FormattedMessage
      id="ValueProps.collabChecklists.valuePropB"
      defaultMessage="Keep your people focused on what they need to do, while you track their progress."
      description="Value prop of Todos feature"
    />,
    <FormattedMessage
      id="ValueProps.collabChecklists.valuePropC"
      defaultMessage={`Avoid "oh crap, I forgot to do that" mistakes. Hey, we all make 'em.`}
      description="Value prop of Todos feature"
    />,
  ];

  return (
    <ValuePropsModal
      title={formattedTitle}
      description={formattedDescription}
      checklistItems={formattedChecklistItems}
      image={Lists}
      isOpen
      onRequestClose={onRequestClose}
      trackingAction="collab_checklist_value_prop_opened"
    />
  );
}

CollabChecklistsValuePropsModal.propTypes = {
  onRequestClose: PropTypes.func,
};
